define('commons/message-filter-form',['jquery', 'commons/filter-form'], function($, FilterForm) {

    function createTooltips(elementClass, tooltipClass) {
        $(elementClass).each(function(index, el) {
            el = $(el);
            var target = el.data("tip-target-id");
            if (target) {
                var content = $("#" + target);
                content.show();
                $(el).tooltip({
                    items: el,
                    tooltipClass: tooltipClass,
                    content: function(fn) {
                        return content;
                    }
                });
                content.remove();
            }
        });
    }

    var MessageFilterForm = function(container, options) {
        var here = this;

        var frameSortContainer = $("#frame-sort-container");
        var repositionFrameSortType = function() {
            var rInfoGlobalHeader = $('#rinfo-global-header');
            if (rInfoGlobalHeader.length) {
                frameSortContainer.css({left: rInfoGlobalHeader.offset().left - $(here.form).offset().left, display : ''});
                frameSortContainer.width(rInfoGlobalHeader.width() + parseFloat(rInfoGlobalHeader.css("padding-left")) + parseFloat(rInfoGlobalHeader.css("padding-right")));
            } else {
                frameSortContainer.css({display: 'none'});
            }
        };
        if (frameSortContainer.length) {
            $(window).resize(function(event) {
                repositionFrameSortType();
            });
            options.onBind = function() {
                repositionFrameSortType();
            };
        }

        // Call parent init method
        FilterForm.call(this, container, options);

        $("#frame-sort-type").change(function(event) {
            here.submit();
        });
    };

    // Inherit from FilterForm
    for ( var element in FilterForm.prototype) {
        MessageFilterForm.prototype[element] = FilterForm.prototype[element];
    }

    // Override handleResult
    MessageFilterForm.prototype.handleResult = function(data) {
        // Call the super method
        FilterForm.prototype.handleResult.call(this, data);
        var filterForm = this;
        $('.more-info').mouseover(function() {
            $(this).find('.background').addClass('hover');
        }).mouseout(function() {
            $(this).find('.background').removeClass('hover');
        }).click(function() {
            var more = $(this);
            var div = $('#' + more.data('messageId'));
            if (div.is(':visible')) {
                div.slideUp({
                    duration: 250,
                    complete: function() {
                        filterForm.decrement();
                        var icon = more.find('.icon-large');
                        icon.removeClass('icon-angle-up');
                        icon.addClass('icon-angle-down');
                    }
                });
            } else {
                filterForm.increment();
                div.slideDown({
                    duration: 250,
                    complete: function() {
                        var icon = more.find('.icon-large');
                        icon.removeClass('icon-angle-down');
                        icon.addClass('icon-angle-up');
                    }
                });
            }
        });
        createTooltips(".base-station-info", "help-ui-tooltip");
        createTooltips(".link-quality-info", "help-ui-tooltip");
        createTooltips(".frames-info", "help-ui-tooltip");
        createTooltips(".repeaters-contribution", "help-ui-tooltip");
    };
    
    return MessageFilterForm;
});
